import { observer } from "mobx-react-lite";

import { PlaceholderLinkField } from "./PlaceholderLinkField";

import type { PlaceholderNodeModel } from "@/models/nodes/PlaceholderNodeModel";

type Props = {
  node: PlaceholderNodeModel;
};

export const PlaceholderStyle = observer(function PlaceholderStyle({ node }: Props) {
  return (
    <div data-panel="placeholder_style" className="px-[5px] pb-2">
      <PlaceholderLinkField node={node} />
    </div>
  );
});
